var map = {
	"./avatar-omar-base-full.png": 72141,
	"./avatar-omar-fall-full.png": 32345,
	"./avatar-omar-spring-full.png": 91588,
	"./avatar-omar-summer-full.png": 56287,
	"./avatar-omar-travel-full.png": 20807,
	"./avatar-omar-winter-full.png": 45644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57738;